import { render, staticRenderFns } from "./Ingredient.vue?vue&type=template&id=4d40c41a&scoped=true"
import script from "./Ingredient.vue?vue&type=script&lang=js"
export * from "./Ingredient.vue?vue&type=script&lang=js"
import style0 from "./Ingredient.vue?vue&type=style&index=0&id=4d40c41a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40c41a",
  null
  
)

export default component.exports